import { Container, Row, Col } from 'react-bootstrap';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer>
      <Container>
        <Row className="align-items-center">
          <Col className="text-center py-3">
            <p>Needs 4 Home &copy; {currentYear}</p>
          </Col>
          <Col className="text-center py-3">
            <p>
              {/* Use mailto: for email links */}
              <a
                className="more-button"
                href="mailto:contact@needs4home.com"
                role="button"
                aria-label="Contact us via email"
              >
                Contact Us Button
              </a>
            </p>
          </Col>
          <Col className="text-center py-3">
            <p>contact@needs4home</p>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

export default Footer;